import { FC } from 'react';
import { State } from 'redux/initialState';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Partner } from 'types';
import { formatCurrencyDecimals } from 'utils/formats';

import { useOperationDetailsPage } from '../../context/OperationDetailsPageContext';
import { useGetDividendDataForPartner } from '../../hooks/useGetDividendDataForPartner';

type DividendsOperationDataRowProps = {
  index: number;
  partner: Partner;
};

const DividendsOperationTableRow: FC<DividendsOperationDataRowProps> = ({
  index,
  partner,
}) => {
  const actualSociety = useSelector(
    (state: State) => state.society.actualSociety
  );
  const { data } = useOperationDetailsPage();

  const { _id: partnerId, name: partnerName } = partner;

  const { data: dividendsData } = useGetDividendDataForPartner({
    dividendOperation: data.operation,
    partner,
  });

  return (
    <>
      <td
        className="text-left vertical-align-middle pl-2 pl-md-2"
        key={`participant-name-${index}`}
      >
        <Link
          className="text-primary"
          to={`/detalle-socio/${actualSociety?._id}/${partnerId}`}
        >
          {partnerName}
        </Link>
      </td>

      <td
        className="text-right vertical-align-middle"
        key={`participant-nd-${index}`}
      >
        {(dividendsData.ndPercentage || 0).toFixed(2)}%
      </td>

      <td
        className="text-right vertical-align-middle d-none d-md-table-cell"
        key={`participant-retention-${index}`}
      >
        {(dividendsData.retentionPercentage || 0).toFixed(2)}%
      </td>

      <td
        className="text-right vertical-align-middle d-none d-md-table-cell"
        key={`participant-amount-${index}`}
      >
        {formatCurrencyDecimals(dividendsData.amount || 0)}
      </td>

      <td
        className="text-right vertical-align-middle pr-2 pr-md-3"
        key={`participant-percibe-${index}`}
      >
        {formatCurrencyDecimals(
          dividendsData.amount - dividendsData.retentionAmount || 0
        )}
      </td>
    </>
  );
};
export default DividendsOperationTableRow;
